// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"203":"language","348":"chat"}[chunkId] + "." + {"203":"13c704dc","348":"54ac05a1"}[chunkId] + ".css";
};